import defaultLocale from './zh_CN';
export default defaultLocale;